<div class="cm-texture-set">
    @if ($data(); as data) {
        <div class="cm-texture-set-header">
            <div class="cm-texture-set-name" [matTooltip]="$textureSetLabel()" matTooltipPosition="above">
                @if ($editName()) {
                    {{ data.textureSet.legacyId }} -
                    <input
                        #nameInput
                        class="cm-name"
                        [cmInput]="data.textureSet.name ?? ''"
                        (change)="changeName($event)"
                        (focusout)="$editName.set(false)"
                        placeholder="Enter a name"
                        [disabled]="!$can().update.textureSet(data.textureSet)"
                    />
                } @else {
                    <span class="cm-texture-set-label" (click)="$canEdit() && $editName.set(true)">
                        {{ data.textureSet.legacyId }} - {{ data.textureSet.name ?? "Untitled" }}
                        @if (data.textureSetRevision; as revision) {
                            ({{ revision.width | number: "1.2-2" }} × {{ revision.height | number: "1.2-2" }} cm)
                        }
                    </span>
                }
            </div>

            @if ($canEdit()) {
                <i class="far fa-trash cm-button cm-delete-texture-set" (click)="deleteTextureSet()" matTooltip="Delete" matTooltipPosition="above"> </i>
            }
            @if ($canEdit() && $can().read.menu("materialAi")) {
                <cm-button class="cm-button" [disabled]="!$isEligibleForMaterialAi() || $isMaterialAiRunning()" (click)="startMaterialAiJob()">
                    @if ($isMaterialAiRunning()) {
                        <ng-container cm-left-icon><i class="far fa-spinner fa-spin"></i></ng-container>
                    } @else {
                        <ng-container cm-left-icon><i class="far fa-stars"></i></ng-container>
                    }
                    <ng-container cm-text>Material AI</ng-container>
                </cm-button>
            }
            @if ($canEdit()) {
                @if (!$showEmptyTextures()) {
                    <div class="cm-show-empty-textures cm-button" (click)="$showEmptyTextures.set(true)">Show empty textures</div>
                } @else {
                    <div class="cm-show-empty-textures cm-button" (click)="$showEmptyTextures.set(false)">Hide empty textures</div>
                }
                <button class="cm-tile-textures cm-button" [routerLink]="['set-revisions', data.textureSetRevisionId]" queryParamsHandling="merge">
                    <i class="far fa-pen"></i>
                    Edit textures
                </button>
            }
        </div>
        <ng-content select="[cm-content]"></ng-content>
        @if ($canEdit()) {
            @for (entry of $activeRevisionJobs(); track entry.jobId) {
                <cm-job-task-progress [jobId]="entry.jobId" [label]="entry.label" (jobCompleted)="onHqProcessingJobCompleted()"></cm-job-task-progress>
            }
        }
        <cm-texture-set-revision-view
            [textureSetId]="data.textureSetId"
            [textureSetRevisionId]="data.textureSetRevisionId"
            [canEdit]="$canEdit()"
            [canDownload]="$canDownload()"
            [showEmptyTextures]="$showEmptyTextures()"
            (showEmptyTexturesChange)="$showEmptyTextures.set($event)"
        ></cm-texture-set-revision-view>
    }
</div>
